import { render, staticRenderFns } from "./OfficialHeader.vue?vue&type=template&id=7170f7fb&scoped=true"
import script from "./OfficialHeader.vue?vue&type=script&lang=js"
export * from "./OfficialHeader.vue?vue&type=script&lang=js"
import style0 from "./OfficialHeader.vue?vue&type=style&index=0&id=7170f7fb&prod&scoped=true&lang=css"
import style1 from "./OfficialHeader.vue?vue&type=style&index=1&id=7170f7fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170f7fb",
  null
  
)

export default component.exports